import React__default from 'react';
import classnames from 'classnames';
import { QuantityDiscountItemLayout } from './QuantityDiscountItemLayout/QuantityDiscountItemLayout.js';

const QuantityDiscountSelect = ({ price , priceIsCentAmount =true , currency , items , selectedValue , onChange , className ,  })=>{
    return /*#__PURE__*/ React__default.createElement("ul", {
        className: classnames('quantity-discount-select', className)
    }, items.map((item)=>{
        return /*#__PURE__*/ React__default.createElement("li", {
            key: item.minimumQuantity
        }, /*#__PURE__*/ React__default.createElement(QuantityDiscountItemLayout, {
            item: item,
            price: price,
            priceIsCentAmount: priceIsCentAmount,
            currency: currency,
            selectedValue: selectedValue,
            onChange: onChange
        }));
    }));
};

export { QuantityDiscountSelect };
//# sourceMappingURL=QuantityDiscountSelect.js.map
